import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function PlanCard({ plan }) {
  return (
    <div
      data-testid={`plan-card-${plan.id}`}
      className={`plan-card rm-card p-8 flex flex-col ${
        plan.featured ? "plan-card-featured ring-2 ring-[#dc2626]" : ""
      }`}
    >
      {plan.featured && (
        <div className="self-start mb-4 px-3 py-1 bg-[#dc2626] text-white text-xs font-bold rounded-full uppercase tracking-wider">
          Najpopularniejszy
        </div>
      )}
      <h3 className="font-display text-3xl font-bold text-[#0f172a]">
        {plan.name}
      </h3>
      <p className="text-sm text-slate-500 mt-1">{plan.tagline}</p>

      <div className="mt-6 flex items-baseline gap-1">
        <span className="font-display text-5xl font-black text-[#1f3a8a]">
          {plan.price}
        </span>
        <span className="text-lg text-slate-500">zł{plan.period}</span>
      </div>

      <p className="mt-4 text-sm text-slate-600 leading-relaxed">
        {plan.description}
      </p>

      <ul className="mt-6 space-y-3 flex-grow">
        {plan.features.map((f, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-slate-700">
            <span className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-[#1f3a8a]/10 text-[#1f3a8a] flex items-center justify-center">
              <Check size={12} strokeWidth={3} />
            </span>
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <Link
        to={`/zamow-sim?plan=${plan.id}`}
        data-testid={`plan-cta-${plan.id}`}
        className={`mt-8 text-center font-bold rounded-full py-3 transition-all ${
          plan.featured
            ? "bg-[#dc2626] text-white hover:bg-[#ef4444]"
            : "bg-[#1f3a8a] text-white hover:bg-[#15296b]"
        }`}
      >
        Wybieram {plan.name}
      </Link>
    </div>
  );
}
